import script from "./AccountBalanceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountBalanceSection.vue?vue&type=script&setup=true&lang=js"

import "./AccountBalanceSection.vue?vue&type=style&index=0&id=606d1318&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-606d1318"]])

export default __exports__